import { __awaiter } from "tslib";
import { DateTime } from 'luxon';
const REQUEST_STATUS = {
    PENDING: 'PENDING',
    RESOLVED: 'RESOVLED',
    REJECTED: 'REJECTED',
};
const cacheRequests = {};
const userPromises = {};
function setCacheRequest(key, exp, result) {
    const cacheExp = DateTime.now().plus({ seconds: exp });
    cacheRequests[key] = {
        result,
        ttl: cacheExp,
        status: REQUEST_STATUS.RESOLVED,
    };
}
function setCacheRequestStatus(key, status) {
    cacheRequests[key] = {
        status,
    };
}
function shouldReturnResultFromCache(ttl = DateTime.now()) {
    return ttl > DateTime.now();
}
function fetchAndCacheRequest(key, exp, promise) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            setCacheRequestStatus(key, REQUEST_STATUS.PENDING);
            userPromises[key] = yield promise();
            setCacheRequest(key, exp, userPromises[key]);
            return userPromises[key];
        }
        catch (err) {
            setCacheRequestStatus(key, REQUEST_STATUS.REJECTED);
            return {};
        }
    });
}
function withCacheRequest(key, exp, promise) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!cacheRequests[key]) {
            // First time this API being called.
            return fetchAndCacheRequest(key, exp, promise);
        }
        const { ttl, result, status } = cacheRequests[key];
        if (status === REQUEST_STATUS.PENDING) {
            // A request is already called, wait for the same response.
            return userPromises[key];
        }
        if (shouldReturnResultFromCache(ttl)) {
            // TTL is not over yet, return result from cache.
            return result;
        }
        // Send new request and save to cache.
        return fetchAndCacheRequest(key, exp, promise);
    });
}
export default withCacheRequest;
